'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const AbstractContent = require('./AbstractContent');

/**
 * ContentSet is used from content which used as container of content
 *
 * 3 type of contentSet exist:
 *
 *  - RootContentSet:
 *     He contain one or several cloudContentSet as first child
 *
 *  - CloudContentSet
 *     He contain one or several colContentSet and used as a row
 *
 *  - ColContentSet
 *    He contain one or several content and used as column
 *
 *  RootContentSet
 *  ----------------------------------------------------------------------
 *  |   CloudContentSet                                                  |
 *  |   --------------------------------------------------------------   |
 *  |   |     ColContentSet     ColContentSet     ColContentSet      |   |
 *  |   |     --------------    --------------    --------------     |   |
 *  |   |     |            |    |            |    |            |     |   |
 *  |   |     --------------    --------------    --------------     |   |
 *  |   --------------------------------------------------------------   |
 *  |                                                                    |
 *  ----------------------------------------------------------------------
 *
 *
 *  @author Florian Kroockmann <florian.kroockmann@lp-digital.fr>
 */
class ContentSet extends AbstractContent {
  /**
   * Retrieve the children of contentset and build as Content
   *
   * If the contentSet is a rootContentSet or colContentSet,
   * the first children is retrieved
   *
   * @returns {object} children
   */
  getChildren() {
    let children = [];

    if (this.$ instanceof jQuery) {
      let $nodeChildren;

      if (this.isRootContentSet() || this.isColContentSet()) {
        $nodeChildren = this.$.children('.bb-content');
      } else {
        $nodeChildren = this.$.find('.row:first')
                              .children('div')
                              .children('.bb-content');
      }

      let ContentManager = require('./../component/ContentManager');

      $nodeChildren.each(function() {
        children.push(ContentManager.getContentByNode(jQuery(this)));
      });
    }

    return children;
  }

  /**
   * Force isSable method to true cause, the check is in an other part
   *
   * @returns {boolean} true
   */
  isSavable() {
    return true;
  }

  /**
   * Return if the contentSet is a colContentSet from the jQuery object
   *
   * @returns {boolean} colcontentset
   */
  isColContentSet() {
      return this.$.hasClass('colcontentset');
  }

  /**
   * Return if the contentSet is a cloudContentSet from the jQuery object
   *
   * @returns {boolean} cloudContentSet
   */
  isRootContentSet() {
    if (this.$ instanceof jQuery) {
      return this.$.hasClass('rootContentSet');
    }

    return false;
  }

  /**
   * Build the boostrap column width the children
   *
   * @returns {AbstractContent} this
   */
  buildColumn() {
    let children = this.getChildren();
    let cols = 12 / (children.length || 1);
    let data = [];

    _.forEach(children, function(child) {
      child.$.parent('div').attr('class', '');
      child.$.parent('div').attr('class', 'col-lg-' + cols);
      data.push(cols);
    });

    this.addParameter('blocksize', data);

    return this;
  }
}

module.exports = ContentSet;
